/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error400CodeEnum,
    Error403LicensePlateCodeEnum,
    Error404CodeEnum,
    Error404DBDeleteCodeEnum,
    Error500CodeEnum,
    Error504CodeEnum,
} from 'client-code/device-binding-service';
import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class SignOutError extends AppError {
    TAG: string = 'SignOutError';

    protected description: string = '';

    protected type: string = '';

    protected title: string = Locale.getString(LocaleKeys.SETTINGS_SIGN_OUT_ERROR);

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.setCode(code);
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }

    private setCode(code: string): void {
        switch (code) {
            case Error400CodeEnum.DbsBadRequestParameters:
                this.code = ErrorTypes.SIGN_OUT_BAD_REQUEST_C701;
                this.type = Error400CodeEnum.DbsBadRequestParameters;
                break;
            case Error500CodeEnum.DbsDynamodbError:
                this.code = ErrorTypes.SIGN_OUT_INTERNAL_SERVER_C702;
                this.type = Error500CodeEnum.DbsDynamodbError;
                break;
            case Error500CodeEnum.DbsGaError:
                this.code = ErrorTypes.SIGN_OUT_GA_ERROR_C705;
                this.type = Error500CodeEnum.DbsGaError;
                break;
            case Error504CodeEnum.DbsIntegrationTimeout:
                this.code = ErrorTypes.SIGN_OUT_INTERNAL_TIMEOUT_C703;
                this.type = Error504CodeEnum.DbsIntegrationTimeout;
                break;
            case Error403LicensePlateCodeEnum.DbsNotAuthorized:
                this.code = ErrorTypes.SIGN_OUT_NOT_AUTHORIZED_C706;
                this.type = Error403LicensePlateCodeEnum.DbsNotAuthorized;
                break;
            case Error404CodeEnum.DbsResourceNotFound:
                this.code = ErrorTypes.SIGN_OUT_NOT_FOUND_C704;
                this.type = Error404CodeEnum.DbsResourceNotFound;
                break;
            case Error404DBDeleteCodeEnum.DbsDeviceBindingNotFoundToRemove:
                this.code = ErrorTypes.SIGN_OUT_DB_NOT_FOUND_TO_REMOVE_C707;
                this.type = Error404DBDeleteCodeEnum.DbsDeviceBindingNotFoundToRemove;
                break;
            default:
                this.code = ErrorTypes.SIGN_OUT_UNKNOWN_C799;
                this.type = 'SIGN_OUT_UNKNOWN_ERROR';
        }
    }
}
